import { FC } from 'react'
import { Box, AppBar, Tabs, Tab } from '@mui/material'
import { RearSurface } from './RearSurface'
import { FrontSurface } from './FrontSurface'
import { TabPanel } from 'src/Components/Ui/TabPanel'
import { a11yProps } from './Figures'
import { tabStyle } from './SettingTabs'
import { SideSurface } from './SideSurface'

type Props = {
  frontSurfaceId: string
  rearSurfaceId: string
  sideSurfaceId: string
  soleSurfaceId: string
  drawerIndex: number
  handleDrawerIndex: (_: unknown, newValue: 0 | 1 | 2 | 3) => void
}

export const SurfaceDrawers: FC<Props> = ({ rearSurfaceId, frontSurfaceId, sideSurfaceId, soleSurfaceId, drawerIndex, handleDrawerIndex }) => {
  return (
    <Box
      position={'sticky'}
      top={0}
      bgcolor={'#fff'}
      sx={{
        height: { xs: 'unset', md: '100vh' }
      }}
    >
      <TabPanel selectedIndex={drawerIndex} index={0}>
        <FrontSurface frontSurfaceId={frontSurfaceId} />
      </TabPanel>
      <TabPanel selectedIndex={drawerIndex} index={1}>
        <SideSurface sideSurfaceId={sideSurfaceId} />
      </TabPanel>
      <TabPanel selectedIndex={drawerIndex} index={2}>
        <RearSurface rearSurfaceId={rearSurfaceId} />
      </TabPanel>
      <AppBar position="static">
        <Tabs value={drawerIndex} onChange={handleDrawerIndex} aria-label="figure-tab-wrapper" centered>
          <Tab label={'正面'} {...a11yProps(2)} style={tabStyle(0, drawerIndex)} />
          <Tab label={'側面'} {...a11yProps(0)} style={tabStyle(1, drawerIndex)} />
          <Tab label={'背面'} {...a11yProps(1)} style={tabStyle(2, drawerIndex)} />
          {/* <Tab label={'底面'} {...a11yProps(3)} style={tabStyle(3, drawerIndex)} /> */}
        </Tabs>
      </AppBar>
    </Box>
  )
}
